import { Skeleton } from 'shared/ui/skeleton';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'shared/ui/table';
interface LoadingDataTableProps {
  columns: number;
  variant?: 'default' | 'list';
  withActins?: boolean;
  rowHeight?: string;
}
export const LoadingDataTable = ({
  columns,
  variant,
  withActins = false,
  rowHeight
}: LoadingDataTableProps) => {
  const columnSkeletons = new Array(columns).fill(null);
  const bodySkeletons = new Array(3).fill(null);

  // @ts-ignore
  return <div data-sentry-component="LoadingDataTable" data-sentry-source-file="loading-data-table.tsx">
      <div className="mb-4 rounded-md">
        <Table variant={variant} data-sentry-element="Table" data-sentry-source-file="loading-data-table.tsx">
          <TableHeader variant={variant} data-sentry-element="TableHeader" data-sentry-source-file="loading-data-table.tsx">
            <TableRow className={`${variant === 'default' ? 'h-[42.5px]' : 'h-8'} [&_th:first-child]:rounded-tl-lg [&_th:last-child]:rounded-tr-lg`} data-sentry-element="TableRow" data-sentry-source-file="loading-data-table.tsx">
              {columnSkeletons.map((_, index) =>
            // eslint-disable-next-line react/no-array-index-key
            <TableHead key={index}>
                  <Skeleton className="h-4.5 min-w-12 max-w-24" />
                </TableHead>)}
              {withActins && <TableHead />}
            </TableRow>
          </TableHeader>

          <TableBody variant={variant} className=" border-collapse [&_tr:last-child_td:first-child]:rounded-bl-lg [&_tr:last-child_td:last-child]:rounded-br-lg" data-sentry-element="TableBody" data-sentry-source-file="loading-data-table.tsx">
            {bodySkeletons.map((_, index) => <TableRow
          /* eslint-disable-next-line react/no-array-index-key */ key={index} variant={variant} className="[&_td]:text-center ">
                {columnSkeletons.map((_, index) =>
            // eslint-disable-next-line react/no-array-index-key
            <TableCell key={index} className={rowHeight || ''}>
                    <Skeleton className="h-4 min-w-12 max-w-24 bg-accent-dark" />
                  </TableCell>)}
                {withActins && <TableCell />}
              </TableRow>)}
          </TableBody>
        </Table>
      </div>
    </div>;
};